import { PARTNER_TYPE_DESCRIPTION } from '../configs'

export function getPartnerTypeDescription(partnerType: string) {
  if (partnerType) {
    const description = PARTNER_TYPE_DESCRIPTION.find(
      (item) => item.key.toUpperCase() === partnerType.toUpperCase()
    )

    return description?.value || ''
  }
  return ''
}
